/* jshint esversion: 6 */
import * as _  from 'underscore';

export default function FilterModule(collection, keys, value, exact) {
	let results = [],
		i = 0,
		length = 0,
		key = '',
		childSearch = [],
		insert = false,
		escapedValue = value.toString().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"),
		re = new RegExp(escapedValue, "i"),
		testValue = '';

	// this will reset the filter
	if (keys === '' && value === '') {
		return [];
	}

	keys = Array.isArray(keys) ? keys : [keys];

	if (exact) {
		re = new RegExp("^" + escapedValue + "$", "i");
	}

	// is collection an array?
	// if it's an object, force it into one for further
	// sausage making
	if (typeof collection.length === "undefined") {
		collection = [collection];
	}

	length = collection.length;
	for (i = 0; i < length; ++i) {
		insert = false;
		for (key in collection[i]) {
			testValue = '';
			if (Array.isArray(collection[i][key]) || _.isObject(collection[i][key])) {
				childSearch = FilterModule(collection[i][key], keys, value);
				if (childSearch.length) {
					insert = true;
				}
			} else {
				testValue = collection[i][key];
				if (testValue !== undefined && testValue !== null) {
					if (typeof collection[i][key].match === "undefined") {
						testValue = testValue.toString();
					}
					if (keys.indexOf(key) >= 0 && testValue.match(re)) {
						insert = true;
					}
				}
			}

		}
		if (insert && results.indexOf(collection[i]) < 0) {
			results.push(collection[i]);
		}
	}

	return results;
}

/** Whether a stored {key, value} filter narrows its list. An empty value is how a search or type filter is reset. */
export function isFilterActive(filter) {
	return Boolean(filter) && filter.value !== undefined && filter.value !== null && filter.value !== '';
}
